var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreenImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98145 1.83728C5.98145 1.62943 6.14994 1.46094 6.35779 1.46094H8.61585C8.8237 1.46094 8.9922 1.62943 8.9922 1.83728V4.09535C8.9922 4.3032 8.8237 4.47169 8.61585 4.47169C8.408 4.47169 8.23951 4.3032 8.23951 4.09535V2.21363H6.35779C6.14994 2.21363 5.98145 2.04513 5.98145 1.83728Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.84119 5.97656C2.04904 5.97656 2.21753 6.14506 2.21753 6.35291V8.23463H4.09925C4.3071 8.23463 4.4756 8.40312 4.4756 8.61097C4.4756 8.81882 4.3071 8.98732 4.09925 8.98732H1.84119C1.63334 8.98732 1.46484 8.81882 1.46484 8.61097V6.35291C1.46484 6.14506 1.63334 5.97656 1.84119 5.97656Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88166 1.57117C9.02864 1.71814 9.02864 1.95643 8.88166 2.1034L6.43543 4.54963C6.28846 4.69661 6.05017 4.69661 5.9032 4.54963C5.75623 4.40266 5.75623 4.16437 5.9032 4.0174L8.34943 1.57117C8.49641 1.42419 8.73469 1.42419 8.88166 1.57117Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55354 5.89929C4.70051 6.04626 4.70051 6.28455 4.55354 6.43152L2.1073 8.87776C1.96033 9.02473 1.72204 9.02473 1.57507 8.87776C1.4281 8.73079 1.4281 8.4925 1.57507 8.34553L4.02131 5.89929C4.16828 5.75232 4.40657 5.75232 4.55354 5.89929Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenImageIcon);
export default __webpack_public_path__ + "static/media/full-screen-image-icon.e6d2f723aa5657f83031772c5f9af677.svg";
export { ForwardRef as ReactComponent };